export class Timestamp {
    constructor(seconds, nanoseconds) {
        this.seconds = seconds;
        this.nanoseconds = nanoseconds;
    }
    static now() {
        return Timestamp.fromMillis(Date.now());
    }
    static fromDate(date) {
        const ms = date.getTime();
        const seconds = Math.floor(ms / 1000);
        const nanoseconds = (ms % 1000) * 1000000;
        return new Timestamp(seconds, nanoseconds);
    }
    static fromMillis(ms) {
        const seconds = Math.floor(ms / 1000);
        const nanoseconds = (ms % 1000) * 1000000;
        return new Timestamp(seconds, nanoseconds);
    }
    toDate() {
        return new Date(this.toMillis());
    }
    toMillis() {
        return this.seconds * 1000 + Math.floor(this.nanoseconds / 1000000);
    }
    toJSON() {
        return {
            __type__: 'timestamp',
            seconds: this.seconds,
            nanoseconds: this.nanoseconds,
        };
    }
}
//# sourceMappingURL=timestamp.js.map